/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Status_Preview_LiveInputs */



/**
* | output |
* | --- |
* | "Live preview — visible to all customers now" |
*
* @param {Partner_Status_Preview_LiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_status_preview_live = /** @type {((inputs?: Partner_Status_Preview_LiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Status_Preview_LiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Live-Vorschau – jetzt für alle Kunden sichtbar")
	return /** @type {LocalizedString} */ ("Live preview — visible to all customers now")
});